/******/ (function() { // webpackBootstrap
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var FullscreenEmailCapture = /*#__PURE__*/function (_HTMLElement) {
  function FullscreenEmailCapture() {
    var _this;
    _classCallCheck(this, FullscreenEmailCapture);
    _this = _callSuper(this, FullscreenEmailCapture);
    _this.init();
    return _this;
  }
  _inherits(FullscreenEmailCapture, _HTMLElement);
  return _createClass(FullscreenEmailCapture, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.setupEventListeners();
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue !== newValue) {
        this.updateAttribute(name, newValue);
      }
    }
  }, {
    key: "init",
    value: function init() {
      // Wait for Globo form to be loaded
      this.waitForGloboForm();
    }
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this2 = this;
      // Listen for custom events from the main document
      document.addEventListener('globo-form-submitted', function (_event) {
        if (_event.target === _this2) {
          _this2.handleFormSubmit(_event);
        }
      });
      document.addEventListener('globo-form-success', function (_event) {
        if (_event.target === _this2) {
          _this2.handleSuccess();
        }
      });
    }
  }, {
    key: "waitForGloboForm",
    value: function waitForGloboForm() {
      var _this3 = this;
      var _checkForm = function checkForm() {
        var globoForm = _this3.querySelector('.globo-form-app');
        if (globoForm) {
          _this3.setupFormListener(globoForm);
        } else {
          // Check again in 100ms if form isn't loaded yet
          setTimeout(_checkForm, 100);
        }
      };
      _checkForm();
    }
  }, {
    key: "setupFormListener",
    value: function setupFormListener(globoForm) {
      var _this4 = this;
      // Listen for form submission events
      globoForm.addEventListener('submit', function (event) {
        _this4.handleFormSubmit(event);
      });

      // Also listen for custom events that Globo might trigger
      globoForm.addEventListener('globo:submit', function (event) {
        _this4.handleFormSubmit(event);
      });

      // Listen for any AJAX responses
      this.observeFormResponses(globoForm);
    }
  }, {
    key: "handleFormSubmit",
    value: function handleFormSubmit(_event) {
      console.log('Globo form submitted');

      // Trigger success UI immediately
      this.handleSuccess();
    }
  }, {
    key: "observeFormResponses",
    value: function observeFormResponses(globoForm) {
      var _this5 = this;
      // Create a mutation observer to watch for changes in the form
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'childList' || mutation.type === 'attributes') {
            // Check if there's a success message
            var successMessage = globoForm.querySelector('.success-message, .globo-success, [data-success]');
            if (successMessage) {
              _this5.handleSuccess();
            }
          }
        });
      });
      observer.observe(globoForm, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'data-success', 'data-error']
      });
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess() {
      console.log('Form submission successful');
      this.triggerSuccessUI();
    }
  }, {
    key: "triggerSuccessUI",
    value: function triggerSuccessUI() {
      // Add success class to the section
      this.classList.add('form-success');

      // Update existing heading and caption with success values
      this.updateHeadingAndCaption();

      // Hide the form
      this.hideForm();

      // Show CTA button
      this.showCTAButton();
    }
  }, {
    key: "updateHeadingAndCaption",
    value: function updateHeadingAndCaption() {
      var successHeading = this.getAttribute('success-heading') || 'Thank you for subscribing!';
      var successMessage = this.getAttribute('success-message') || "You'll receive our latest updates and exclusive offers.";

      // Update the existing heading
      var headingElement = this.querySelector('.fullscreen-email-capture__heading');
      if (headingElement) {
        headingElement.textContent = successHeading;
      }

      // Update the existing caption
      var captionElement = this.querySelector('.fullscreen-email-capture__caption');
      if (captionElement) {
        captionElement.textContent = successMessage;
      }
    }
  }, {
    key: "hideForm",
    value: function hideForm() {
      var formContainer = this.querySelector('.globo-formbuilder');
      var termsText = this.querySelector('.fullscreen-email-capture__terms');
      if (formContainer) {
        formContainer.style.display = 'none';
        termsText.style.display = 'none';
      }
    }
  }, {
    key: "showCTAButton",
    value: function showCTAButton() {
      var ctaButton = this.querySelector('.fullscreen-email-capture__cta');
      if (ctaButton) {
        ctaButton.style.display = 'inline-block';
      }
    }
  }, {
    key: "updateAttribute",
    value: function updateAttribute(name, value) {
      switch (name) {
        case 'success-message':
          {
            // Update caption if already in success state
            if (this.classList.contains('form-success')) {
              var captionElement = this.querySelector('.fullscreen-email-capture__caption');
              if (captionElement) {
                captionElement.textContent = value;
              }
            }
            break;
          }
        case 'success-heading':
          {
            // Update heading if already in success state
            if (this.classList.contains('form-success')) {
              var headingElement = this.querySelector('.fullscreen-email-capture__heading');
              if (headingElement) {
                headingElement.textContent = value;
              }
            }
            break;
          }
        case 'cta-text':
        case 'cta-url':
          {
            // Update CTA button if already in success state
            if (this.classList.contains('form-success')) {
              this.showCTAButton();
            }
            break;
          }
      }
    }

    // Public methods for external control
  }, {
    key: "reset",
    value: function reset() {
      this.classList.remove('form-success');

      // Restore original heading and caption
      var originalHeading = this.getAttribute('data-original-heading');
      var originalCaption = this.getAttribute('data-original-caption');
      var headingElement = this.querySelector('.fullscreen-email-capture__heading');
      if (headingElement && originalHeading) {
        headingElement.textContent = originalHeading;
      }
      var captionElement = this.querySelector('.fullscreen-email-capture__caption');
      if (captionElement && originalCaption) {
        captionElement.textContent = originalCaption;
      }

      // Show form again
      var formContainer = this.querySelector('.globo-formbuilder');
      if (formContainer) {
        formContainer.style.display = '';
      }

      // Hide CTA button
      var ctaButton = this.querySelector('.fullscreen-email-capture__cta');
      if (ctaButton) {
        ctaButton.style.display = 'none';
      }
    }
  }, {
    key: "triggerSuccess",
    value: function triggerSuccess() {
      this.handleSuccess();
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['success-heading', 'success-message', 'cta-text', 'cta-url'];
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the custom element
customElements.define('fullscreen-email-capture', FullscreenEmailCapture);

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function () {
  // Convert existing sections to use the web component
  var sections = document.querySelectorAll('[data-section-type="fullscreen-email-capture"]');
  sections.forEach(function (section) {
    if (!(section instanceof FullscreenEmailCapture)) {
      // Create a new web component and move the content
      var webComponent = document.createElement('fullscreen-email-capture');

      // Copy attributes
      Array.from(section.attributes).forEach(function (attr) {
        webComponent.setAttribute(attr.name, attr.value);
      });

      // Store original heading and caption for reset functionality
      var headingElement = section.querySelector('.fullscreen-email-capture__heading');
      var captionElement = section.querySelector('.fullscreen-email-capture__caption');
      if (headingElement) {
        webComponent.setAttribute('data-original-heading', headingElement.textContent);
      }
      if (captionElement) {
        webComponent.setAttribute('data-original-caption', captionElement.textContent);
      }

      // Move content
      while (section.firstChild) {
        webComponent.appendChild(section.firstChild);
      }

      // Replace the section
      section.parentNode.replaceChild(webComponent, section);
    }
  });
});

// Also initialize for dynamic content (if using AJAX)
document.addEventListener('shopify:section:load', function (event) {
  if (event.target.getAttribute('data-section-type') === 'fullscreen-email-capture') {
    // The section will be automatically converted by the DOMContentLoaded listener
  }
});
/******/ })()
;